<app-card>
    <form novalidate [formGroup]="skillsForm" (ngSubmit)="onSubmit()">
        <div class="title">
            <span class="header-title">{{ 'skill_data' | translate }}</span>
            <button mat-icon-button (click)="toggleSkills()" type="button">
                <mat-icon *ngIf="!isEnabled" svgIcon="{{isEnabled ? 'expand_less' : 'expand_more'}}"></mat-icon>
            </button>
        </div>
        <mat-accordion class="skill-card-wrapper" multi>
            <mat-expansion-panel class="skill-expansion-panel" [expanded]="!isConsult">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="skill-card-header">
                            <div>
                                <span class="skill-header-title">{{'languages_skills' | translate}}</span>
                                <span *ngIf="cvType==='CONSULTANT_CV'" class="fa fa-info-circle" data-toggle="tooltip"
                                    title="{{'max_number_of_parts' | translate: {number: ('5 ' + ('languages' | translate)) } }}"></span>
                            </div>
                            <button mat-mini-fab color="primary" class="icon-button add-new-item-button"
                                (click)="$event.stopPropagation(); addNewItem('languages')" type="button">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="skill-card-body">
                    <table id="languages_table" class="w-100 drag-list" cdkDropList
                        [cdkDropListDisabled]="!isConsult || skillsForm.get('languages').controls.length < 2">
                        <ng-container formArrayName="languages">
                            <tr class="table-row drag-box" cdkDrag (cdkDragDropped)="itemDropped($event, 'languages')"
                                *ngFor="let language of skillsForm.get('languages').controls; let l=index;trackBy:trackByIndex"
                                [formGroupName]="l">
                                <div class="custom-drag-placeholder" *cdkDragPlaceholder></div>
                                <td *ngIf="isConsult">
                                    <div class="buttons-row">
                                        <img class="cursor-move"
                                            src="assets/icons/drag_handle.svg"
                                            *ngIf="skillsForm.get('languages').controls.length > 1"
                                            cdkDragHandle>
                                        <img style="height: 24px;" class="cursor-pointer"
                                            src="assets/icons/visibility.svg"
                                            *ngIf="isItemSelected(l,'languages')"
                                            (click)="handleSelect(l, 'languages', skills?.languages)">
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility_off.svg"
                                            *ngIf="!isItemSelected(l,'languages')"
                                            (click)="handleSelect(l, 'languages', skills?.languages)">
                                    </div>
                                </td>
                                <td class="w-100">
                                    <input type="hidden" formControlName="id">
                                    <input type="hidden" formControlName="selected">
                                    <mat-form-field appearance="outline" color="secondary">
                                        <input matInput [ngClass]="{'inactive': !isItemSelected(l,'languages')}"
                                            placeholder="{{'language' | translate}}" id="{{'lang_'+l}}"
                                            autocomplete="off" maxlength="30" formControlName="name" type="text"
                                            required>
                                        <mat-error *ngIf="skillsForm.hasError('maxlength', 'languages')">
                                            {{ 'err_msg_maxlength' | translate: {'number': 30} }}
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td class="w-100">
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="languageLevel"
                                            [ngClass]="{'inactive': !isItemSelected(l,'languages')}"
                                            placeholder="{{'language_level' | translate}}" id="{{'level_'+l}}" required>
                                            <mat-option *ngFor="let level of languageLevels" [value]="level">{{
                                                'language_levels.' + level | translate }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td class="align-self-start">
                                    <button mat-mini-fab color="primary" class="icon-button item-icon-button"
                                        (click)="delete(l, 'languages')" type="button">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                    <small *ngIf="skillsForm.get('languages').touched && skillsForm.get('languages').invalid"
                        class="form-text text-error text-center">
                        {{'err_msg_pair_fields' | translate}}
                    </small>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="skill-expansion-panel" [expanded]="!isConsult">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="skill-card-header">
                            <span class="skill-header-title">{{'branch_skills' | translate}}</span>
                            <span *ngIf="cvType==='CONSULTANT_CV'" class="fa fa-info-circle" data-toggle="tooltip"
                                title="{{'max_number_of_parts' | translate: {number: ('4 ' + ('branch_skills' | translate)) } }}"></span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="skill-card-body">
                    <ng-multiselect-dropdown appendTo="body" [placeholder]="'select'|translate" [settings]="dropdownSettings"
                        [data]="allBranches" [formControl]="skillsForm.controls['branches']"
                        (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)">
                    </ng-multiselect-dropdown>
                </div>
                <table *ngIf="isConsult && skills.branches.length>1" class="w-100 branch-table drag-list"
                    cdkDropList [cdkDropListDisabled]="skills.branches.length < 2">
                    <ng-container>
                        <tr *ngFor="let branch of skills.branches; let b=index; trackBy:trackByIndex"
                            class="branch-table-row drag-box" cdkDrag
                            (cdkDragDropped)="itemDropped($event, 'branches')">
                            <div class="custom-drag-placeholder" *cdkDragPlaceholder></div>
                            <td style="display: flex; padding-right: 10px;">
                                <mat-icon *ngIf="skills.branches.length > 1" class="cursor-move" svgIcon="drag_handle"
                                    cdkDragHandle></mat-icon>
                            </td>
                            <td style="width:90%">
                                <span id="{{'branch_'+b}}">{{(translate.currentLang == 'en') ? branch.nameEn :
                                    branch.name}}</span>
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </mat-expansion-panel>
            <mat-expansion-panel class="skill-expansion-panel" [expanded]="!isConsult">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="skill-card-header">
                            <div>
                                <span class="skill-header-title">{{'certifications' | translate}}</span>
                                <span *ngIf="cvType==='CONSULTANT_CV'" class="fa fa-info-circle" data-toggle="tooltip"
                                    title="{{'max_number_of_parts' | translate: {number: ('4 ' + ('certifications' | translate)) } }}"></span>
                            </div>
                            <button mat-mini-fab color="primary" class="icon-button add-new-item-button"
                                (click)="$event.stopPropagation(); addNewItem('certificates')" type="button">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="skill-card-body">
                    <table id="certificats_table" class="w-100 drag-list" cdkDropList
                        [cdkDropListDisabled]="!isConsult || skillsForm.get('certificates').controls.length < 2">
                        <ng-container formArrayName="certificates">
                            <tr class="table-row drag-box" cdkDrag
                                (cdkDragDropped)="itemDropped($event, 'certificates')"
                                *ngFor="let cert of skillsForm.get('certificates').controls; let c=index;trackBy:trackByIndex"
                                [formGroupName]="c">
                                <div class="custom-drag-placeholder" *cdkDragPlaceholder></div>
                                <td *ngIf="isConsult">
                                    <div class="buttons-row">
                                        <img class="cursor-move"
                                            src="assets/icons/drag_handle.svg"
                                            *ngIf="skillsForm.get('certificates').controls.length > 1"
                                            cdkDragHandle>
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility.svg"
                                            *ngIf="isItemSelected(c,'certificates')"
                                            (click)="handleSelect(c, 'certificates', skills?.certificates)">
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility_off.svg"
                                            *ngIf="!isItemSelected(c,'certificates')"
                                            (click)="handleSelect(c, 'certificates', skills?.certificates)">
                                    </div>
                                </td>
                                <td class="w-100">
                                    <input type="hidden" formControlName="id">
                                    <input type="hidden" formControlName="selected">
                                    <mat-form-field appearance="outline" color="secondary">
                                        <input matInput [ngClass]="{'inactive': !isItemSelected(c,'certificates')}"
                                            autocomplete="off" placeholder="{{'certificate' | translate}}"
                                            id="{{'cert_'+c}}" maxlength="50" type="text" formControlName="name"
                                            required>
                                        <mat-error *ngIf="skillsForm.hasError('maxlength', 'certificates')">
                                            {{ 'err_msg_maxlength' | translate: {'number': 30} }}
                                        </mat-error>
                                        <mat-error *ngIf="skillsForm.hasError('minlength', 'certificates')">
                                            {{'err_msg_please_fill' | translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td class="w-100" style="align-self: center;">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{'date_certificate' | translate}}</mat-label>
                                        <input matInput id="{{'date_'+c}}"
                                            [ngClass]="{'inactive': !isItemSelected(c,'certificates')}"
                                            placeholder="{{'date_certificate' | translate}}"
                                            formControlName="certificateDate" [matDatepicker]="certificatePicker"
                                            [max]="minAllowedDate" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="certificatePicker">
                                            <mat-icon matDatepickerToggleIcon svgIcon="calendar_month"></mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #certificatePicker></mat-datepicker>
                                    </mat-form-field>
                                </td>
                                <td class="align-self-start">
                                    <button mat-mini-fab color="primary" class="icon-button item-icon-button"
                                        (click)="delete(c, 'certificates')" type="button">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                    <div class="mt-2">
                        <small *ngIf="skillsForm.get('certificates').touched && skillsForm.get('certificates').invalid"
                            class="form-text text-error text-center">
                            {{'err_msg_pair_fields' | translate}}
                        </small>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="skill-expansion-panel" [expanded]="!isConsult">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="skill-card-header">
                            <div>
                                <span class="skill-header-title">{{'it_skills' | translate}}</span>
                                <span *ngIf="cvType==='CONSULTANT_CV'" class="fa fa-info-circle" data-toggle="tooltip"
                                    title="{{'max_number_of_parts' | translate: {number: ('8 ' + ('it_skills' | translate)) } }}"></span>
                            </div>
                            <button mat-mini-fab color="primary" class="icon-button add-new-item-button"
                                (click)="$event.stopPropagation(); addNewItem('itCompetences')" type="button">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="skill-card-body">
                    <table class="w-100 px-0 drag-list" cdkDropList
                        [cdkDropListDisabled]="!isConsult || skillsForm.get('itCompetences').controls.length < 2">
                        <ng-container formArrayName="itCompetences">
                            <tr class="table-row drag-box" cdkDrag
                                (cdkDragDropped)="itemDropped($event, 'itCompetences')"
                                *ngFor="let it of skillsForm.get('itCompetences').controls; let i=index; trackBy:trackByIndex"
                                [formGroupName]="i">
                                <div class="custom-drag-placeholder" *cdkDragPlaceholder></div>
                                <td *ngIf="isConsult">
                                    <div class="buttons-row">
                                        <img class="cursor-move"
                                            src="assets/icons/drag_handle.svg"
                                            *ngIf="skillsForm.get('itCompetences').controls.length > 1"
                                            cdkDragHandle>
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility.svg"
                                            *ngIf="isItemSelected(i,'itCompetences')"
                                            (click)="handleSelect(i, 'itCompetences', skills?.itCompetences)">
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility_off.svg"
                                            *ngIf="!isItemSelected(i,'itCompetences')"
                                            (click)="handleSelect(i, 'itCompetences', skills?.itCompetences)">
                                    </div>
                                </td>
                                <td class="w-100">
                                    <input type="hidden" formControlName="id">
                                    <input type="hidden" formControlName="selected">
                                    <mat-form-field appearance="outline" color="secondary">
                                        <input matInput [ngClass]="{'inactive': !isItemSelected(i,'itCompetences')}"
                                            placeholder="{{'knowledge' | translate}}" autocomplete="off" maxlength="30"
                                            id="{{'it_'+i}}" type="text" formControlName="name" required>
                                        <mat-error *ngIf="skillsForm.hasError('maxlength', 'itCompetences')">
                                            {{ 'err_msg_maxlength' | translate: {'number': 35} }}
                                        </mat-error>
                                        <mat-error *ngIf="skillsForm.hasError('minlength', 'itCompetences')">
                                            {{'err_msg_please_fill' | translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td class="slider-container">
                                    <mat-slider class="skill-slider" [max]="100" [min]="60" [step]="5"
                                        [showTickMarks]="true">
                                        <input matSliderThumb placeholder="{{'rate_percent' | translate}}"
                                            id="percentageCompetence" formControlName="percentageCompetence">
                                    </mat-slider>
                                </td>
                                <td class="align-self-start">
                                    <button mat-mini-fab color="primary" style="margin-top: 14px;"
                                        class="icon-button item-icon-button" (click)="delete(i, 'itCompetences')"
                                        type="button">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="skill-expansion-panel" [expanded]="!isConsult">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="skill-card-header">
                            <div>
                                <span class="skill-header-title">{{'technical_skills' | translate}}</span>
                                <span *ngIf="cvType==='CONSULTANT_CV'" class="fa fa-info-circle" data-toggle="tooltip"
                                    title="{{'max_number_of_parts' | translate: {number: ('8 ' + ('technical_skills' | translate)) } }}"></span>
                            </div>
                            <button mat-mini-fab color="primary" class="icon-button add-new-item-button"
                                (click)="$event.stopPropagation(); addNewItem('professionalCompetences')" type="button">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="skill-card-body">
                    <table class="w-100 px-0 drag-list" cdkDropList
                        [cdkDropListDisabled]="!isConsult || skillsForm.get('professionalCompetences').controls.length < 2">
                        <ng-container formArrayName="professionalCompetences">
                            <tr class="table-row drag-box" cdkDrag
                                (cdkDragDropped)="itemDropped($event, 'professionalCompetences')"
                                *ngFor="let prof of skillsForm.get('professionalCompetences').controls; let p=index; trackBy:trackByIndex"
                                [formGroupName]="p">
                                <div class="custom-drag-placeholder" *cdkDragPlaceholder></div>
                                <td *ngIf="isConsult">
                                    <div class="buttons-row">
                                        <img class="cursor-move"
                                            src="assets/icons/drag_handle.svg"
                                            *ngIf="skillsForm.get('professionalCompetences').controls.length > 1"
                                            cdkDragHandle>
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility.svg"
                                            *ngIf="isItemSelected(p,'professionalCompetences')"
                                            (click)="handleSelect(p, 'professionalCompetences', skills?.professionalCompetences)">
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility_off.svg"
                                            *ngIf="!isItemSelected(p,'professionalCompetences')"
                                            (click)="handleSelect(p, 'professionalCompetences', skills?.professionalCompetences)">
                                    </div>
                                </td>
                                <td class="w-100">
                                    <input type="hidden" formControlName="id">
                                    <input type="hidden" formControlName="selected">
                                    <mat-form-field appearance="outline" color="secondary">
                                        <input matInput placeholder="{{'competence' | translate}}"
                                            [ngClass]="{'inactive': !isItemSelected(p,'professionalCompetences')}"
                                            autocomplete="off" maxlength="30" id="{{'prof_'+p}}" type="text"
                                            formControlName="name" required>
                                        <mat-error
                                            *ngIf="skillsForm.hasError('maxlength', 'professionalCompetences')">
                                            {{ 'err_msg_maxlength' | translate: {'number': 35} }}
                                        </mat-error>
                                        <mat-error
                                            *ngIf="skillsForm.hasError('minlength', 'professionalCompetences')">
                                            {{'err_msg_please_fill' | translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td class="slider-container">
                                    <mat-slider class="skill-slider" [max]="100" [min]="60" [step]="5"
                                        [showTickMarks]="true">
                                        <input id="profLevel" placeholder="{{'rate_percent' | translate}}"
                                            matSliderThumb formControlName="percentageCompetence">
                                    </mat-slider>
                                </td>
                                <td class="align-self-start">
                                    <button mat-mini-fab color="primary" style="margin-top: 14px;"
                                        class="icon-button item-icon-button"
                                        (click)="delete(p, 'professionalCompetences')" type="button">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="skill-expansion-panel" [expanded]="!isConsult">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="skill-card-header">
                            <div>
                                <span class="skill-header-title">{{'activities' | translate}}</span>
                                <span *ngIf="cvType==='CONSULTANT_CV'" class="fa fa-info-circle" data-toggle="tooltip"
                                    title="{{'max_number_of_parts' | translate: {number: ('5 ' + ('activities' | translate)) } }}"></span>
                            </div>
                            <button
                                mat-mini-fab
                                color="primary"
                                class="icon-button add-new-item-button"
                                (click)="$event.stopPropagation(); addNewItem('activities')"
                                type="button"
                            >
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="skill-card-body">
                    <table class="w-100 px-0 drag-list" cdkDropList
                        [cdkDropListDisabled]="!isConsult || skillsForm.get('activities').controls.length < 2">
                        <ng-container formArrayName="activities">
                            <tr class="table-row drag-box" cdkDrag (cdkDragDropped)="itemDropped($event, 'activities')"
                                *ngFor="let activityControl of skillsForm.get('activities').controls; let i=index; trackBy: trackByIndex"
                                [formGroupName]="i">
                                <div class="custom-drag-placeholder" *cdkDragPlaceholder></div>
                                <td *ngIf="isConsult">
                                    <div class="buttons-row">
                                        <img class="cursor-move"
                                            src="assets/icons/drag_handle.svg"
                                            *ngIf="skillsForm.get('activities').controls.length > 1"
                                            cdkDragHandle>
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility.svg"
                                            *ngIf="isItemSelected(i,'activities')"
                                            (click)="handleSelect(i, 'activities', skills?.activities)">
                                        <img class="cursor-pointer"
                                            src="assets/icons/visibility_off.svg"
                                            *ngIf="!isItemSelected(i,'activities')"
                                            (click)="handleSelect(i, 'activities', skills?.activities)">
                                    </div>
                                </td>
                                <td class="w-100">
                                    <input type="hidden" formControlName="id">
                                    <input type="hidden" formControlName="selected">
                                    <mat-form-field appearance="outline" color="secondary">
                                        <input matInput [ngClass]="{'inactive': !isItemSelected(i,'activities')}"
                                               autocomplete="off" maxlength="45" id="{{'act_'+i}}" type="text"
                                               formControlName="name" required
                                               placeholder="{{'activities' | translate}}">
                                        <mat-error *ngIf="skillsForm.hasError('maxlength', 'activities')">
                                            {{ 'err_msg_maxlength' | translate: {'number': 45} }}
                                        </mat-error>
                                        <mat-error *ngIf="skillsForm.hasError('minlength', 'activities')">
                                            {{'err_msg_please_fill' | translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </td>
                                <td class="align-self-start">
                                    <button mat-mini-fab color="primary" class="icon-button item-icon-button"
                                            (click)="delete(i, 'activities')" type="button">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <section class="action-block">
            <button class="save-button" mat-button type="submit" [disabled]="skillsForm.invalid">
                {{ 'save_skill_data_label' | translate }}
            </button>
        </section>

        <section class="errors-block">
            <mat-error *ngIf="skillsForm.invalid">
              {{ 'there_are_mandatory_fields' | translate }}
            </mat-error>
          </section>    
    </form>
</app-card>
